
  Vue.component('tab-view-pager', {
    props: {
      initialPage: { type: Number, default: 1 },
      pages: { type: Array, required: true }
    },
    data() {
      return {
        currentPage: this.initialPage
      }
    },
    template: '#tab-view-pager',
    computed: {
      content() {
        return this.pages.find(page => page.id === this.currentPage).content
      },
      title() {
        return this.pages.find(page => page.id === this.currentPage).title
      }
    },
    watch: {},
    methods: {
      gotoPage(page) {
        this.currentPage = page
      }
    },
    mounted() {}
  })
